import { useEffect, useState } from "react";
import { getMotionPerformanceProfile } from "@/lib/motionPerformance";

const PHRASES = [
  "Data Management",
  "Smart Dashboards",
  "Website Design",
  "Brand Identity",
  "AI & Automation",
  "Business Growth",
];

export default function TypewriterText() {
  const initialStaticHeadline = typeof window !== "undefined"
    && getMotionPerformanceProfile(
      window.innerWidth,
      window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    ).staticHeadline;
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [displayed, setDisplayed] = useState(initialStaticHeadline ? "Data Management" : "");
  const [isDeleting, setIsDeleting] = useState(false);
  const [cursor, setCursor] = useState(true);
  const [staticHeadline, setStaticHeadline] = useState(initialStaticHeadline);

  useEffect(() => {
    const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    const updateProfile = () => {
      setStaticHeadline(
        getMotionPerformanceProfile(window.innerWidth, motionQuery.matches).staticHeadline,
      );
    };

    updateProfile();
    motionQuery.addEventListener("change", updateProfile);
    window.addEventListener("resize", updateProfile, { passive: true });
    return () => {
      motionQuery.removeEventListener("change", updateProfile);
      window.removeEventListener("resize", updateProfile);
    };
  }, []);

  useEffect(() => {
    if (staticHeadline) return;
    const interval = setInterval(() => setCursor((current) => !current), 500);
    return () => clearInterval(interval);
  }, [staticHeadline]);

  useEffect(() => {
    if (staticHeadline) return;
    const current = PHRASES[phraseIndex];
    let timeout: ReturnType<typeof setTimeout> | undefined;

    if (!isDeleting && displayed.length < current.length) {
      timeout = setTimeout(() => setDisplayed(current.slice(0, displayed.length + 1)), 80);
    } else if (!isDeleting && displayed.length === current.length) {
      timeout = setTimeout(() => setIsDeleting(true), 2000);
    } else if (isDeleting && displayed.length > 0) {
      timeout = setTimeout(() => setDisplayed(current.slice(0, displayed.length - 1)), 45);
    } else if (isDeleting) {
      setIsDeleting(false);
      setPhraseIndex((index) => (index + 1) % PHRASES.length);
    }

    return () => timeout && clearTimeout(timeout);
  }, [displayed, isDeleting, phraseIndex, staticHeadline]);

  if (staticHeadline) {
    return <span style={{ color: "#4f8cff" }}>Data Management</span>;
  }

  return (
    <span style={{ color: "#4f8cff" }}>
      {displayed}
      <span
        aria-hidden="true"
        style={{
          display: "inline-block",
          width: "3px",
          height: "0.85em",
          background: cursor ? "#4f8cff" : "transparent",
          marginLeft: "2px",
          verticalAlign: "middle",
          borderRadius: "1px",
          transition: "background 0.1s",
        }}
      />
    </span>
  );
}
